import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'suka-popover-section',
  template: `
    <ng-content></ng-content>
  `,
})
export class PopoverSection {
  @HostBinding('class.popover__section') baseClass = true;
}
